import { render } from "./PageMentionNode.vue?vue&type=template&id=359f637c&ts=true&lang=html"
import script from "./PageMentionNode.vue?vue&type=script&lang=ts"
export * from "./PageMentionNode.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__